export default __webpack_public_path__ + "static/media/mediaPlaceholder.ae7c7f2d.jpg";